var map = {
	"./background.svg": "g+Js",
	"./collapse.svg": "2qk3",
	"./email.svg": "Jvlx",
	"./home.svg": "GU1v",
	"./pay-alipay.svg": "n8pt",
	"./pay-bank.svg": "Djnt",
	"./pay-taobao.svg": "vqQK",
	"./pay-wechat.svg": "H2z5",
	"./search.svg": "EqOI",
	"./success.svg": "TBqF",
	"./u1217.svg": "TaIQ",
	"./u164.svg": "wlBH",
	"./u2752.svg": "LrV+",
	"./u738.svg": "Qmqp",
	"./u98.svg": "yHxA",
	"./wechat.svg": "R0XQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VZYf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg nonrecursive \.svg$
// module id = VZYf
// module chunks = 9